module.exports = __webpack_public_path__ + "img/793.dfc75c04.png";